<template>
  <UserForm :user="user" :onSubmit="submit"></UserForm>
</template>

<script>
import UserForm from './User-Form.vue';
import { UserStoreModel } from '../../store/modules/users';
import { busEvent } from '../../main';

export default {
  name: 'create-user',
  components: {
    UserForm,
  },
  data: () => ({
    user: { ...UserStoreModel },
  }),
  methods: {
    submit() {
      this.$store.dispatch('users/createUser', this.user)
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Userul a fost creat');
          this.$router.push({ path: '/users' });
        });
    },
  },
};
</script>
